import type {ReactNode} from 'react'
import type {Moment} from 'moment-timezone'
import type {TranslateT} from '@freckle/educator-entities/ts/common/helpers/translate'

export function formatRoundedNumber(digit: number): (cell?: number | null) => string {
  return function roundedNumber(cell: number | undefined | null): string {
    return cell !== null && cell !== undefined ? cell.toFixed(digit) : '—'
  }
}

export const formatMoment = (format: string, cell?: Moment | null): ReactNode => {
  if (cell === null || cell === undefined) {
    return <span>&mdash;</span>
  }
  return <span>{cell.format(format)}</span>
}

export function formatGrade(cell: number | undefined | null, t: TranslateT): string {
  if (cell === null || cell === undefined) {
    return '—'
  }
  return t('DISPLAY_GRADE_ORDINAL', {grade: cell})
}
